import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import { filter, map } from 'lodash'

import { centsToDollars } from '../../utils/formatters'
import { nonZeroDisplayAmount } from '../../utils/orderUtils'

import styles from './TabOrderTotals.module.scss'

const TabOrderTotals = ({
  className,
  highlightExemptions,
  discount,
  exemptions,
  isFrozen,
  nonExemptableTaxRules,
  serviceCharge,
  serviceChargeName,
  subtotal,
  tax,
  tip,
  total,
  ...props
}) => {
  const classNames = cn(styles.tabOrderTotals, className)

  const renderNonExemptTaxes = () => {
    const displayRules = filter(nonExemptableTaxRules, 'display')
    if (displayRules.length < 1) return null

    const content = map(displayRules, rule => {
      return (
        <div key={rule.taxRuleUuid} className={styles.row}>
          <span>{rule.name}</span>
          <span>{centsToDollars(rule.taxAmountInCents)}</span>
        </div>
      )
    })

    return content
  }

  return (
    <div {...props} className={classNames}>
      <div className={styles.row}>
        <span>Subtotal</span>
        <span>{subtotal}</span>
      </div>
      <div className={styles.row}>
        <span>Discount</span>
        <span className={(highlightExemptions && exemptions.applyDiscount) ? styles.highlighted : null}>{nonZeroDisplayAmount(discount) ? discount : '-'}</span>
      </div>
      <div className={styles.row}>
        <span>{serviceChargeName}</span>
        <span className={(highlightExemptions && exemptions.applyServiceFee) ? styles.highlighted : null}>{nonZeroDisplayAmount(serviceCharge) ? serviceCharge : '-'}</span>
      </div>
      <div className={styles.row}>
        <span>Sales Tax</span>
        <span className={(highlightExemptions && exemptions.applySalesTax) ? styles.highlighted : null}>{nonZeroDisplayAmount(tax) ? tax : '-'}</span>
      </div>
      {renderNonExemptTaxes()}
      <div className={styles.row}>
        <span>Gratuity</span>
        <span>{tip}</span>
      </div>
      <div className={styles.row}>
        <span>Grand Total</span>
        <span>{nonZeroDisplayAmount(total) ? total : '-'}</span>
      </div>
    </div>
  )
}

TabOrderTotals.defaultProps = {
  discount: '-',
  exemptions: {},
  highlightExemptions: false,
  itemCount: 0,
  nonExemptableTaxRules: [],
  serviceCharge: '-',
  serviceChargeName: 'Service Charge',
  subtotal: '-',
  tax: '-',
  tip: '-',
  total: '-',
}

TabOrderTotals.propTypes = {
  discount: PropTypes.string,
  exemptions: PropTypes.object,
  highlightExemptions: PropTypes.bool,
  itemCount: PropTypes.number,
  nonExemptableTaxRules: PropTypes.array,
  serviceCharge: PropTypes.string,
  serviceChargeName: PropTypes.string,
  subtotal: PropTypes.string,
  tax: PropTypes.string,
  tip: PropTypes.string,
  total: PropTypes.string,
}

export default TabOrderTotals
